import { Button, Flex } from "@chakra-ui/react";
import React, { memo } from "react";

interface StepControllerProps {
  currentStep: number;
  totalSteps: number;
  onNext: () => void;
  onBack: () => void;
  onCancel: () => void;
  onSubmit: () => void;
  isNextDisabled?: boolean;
  t: (key: string) => string;
  isSubmitting?: boolean;
}

export const StepController: React.FC<StepControllerProps> = memo(
  ({
    currentStep,
    totalSteps,
    onNext,
    onBack,
    onCancel,
    onSubmit,
    isNextDisabled = false,
    t,
    isSubmitting,
  }) => {
    const isLastStep = currentStep === totalSteps - 1;
    const isFirstStep = currentStep === 0;

    return (
      <Flex gap={3} justify="flex-end" pt={4}>
        {isFirstStep && (
          <Button variant="ghost" color="newBlue.500" onClick={onCancel}>
            {t("cancel")}
          </Button>
        )}

        {!isFirstStep && (
          <Button color="newBlue.500" variant="outline" onClick={onBack}>
            {t("back")}
          </Button>
        )}

        {!isLastStep ? (
          <Button
            layerStyle="ocean"
            _hover={{ layerStyle: "ocean" }}
            onClick={onNext}
            isDisabled={isNextDisabled}
          >
            {t("continue")}
          </Button>
        ) : (
          <Button
            layerStyle="ocean"
            _hover={{ layerStyle: "ocean" }}
            onClick={onSubmit}
            isLoading={isSubmitting}
          >
            {t("createAlert")}
          </Button>
        )}
      </Flex>
    );
  }
);
